import { api } from './api';

export interface User {
  id: number;
  email: string;
  name: string;
  role: string;
  tenantId: number;
  isActive: boolean;
  lastLogin?: string;
  tenant?: {
    id: number;
    name: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface UserCreate {
  email: string;
  password: string;
  name: string;
  role?: string;
  tenantId?: number;
}

export interface UserUpdate {
  email?: string;
  password?: string;
  name?: string;
  role?: string;
  isActive?: boolean;
  tenantId?: number;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const userService = {
  getAll: async (page = 1, limit = 10, search?: string, role?: string, tenantId?: number): Promise<PaginatedResponse<User>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (search) params.append('search', search);
    if (role) params.append('role', role);
    if (tenantId) params.append('tenantId', tenantId.toString());
    
    const response = await api.get<PaginatedResponse<User>>(`/users?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { user: User } }> => {
    const response = await api.get<{ data: { user: User } }>(`/users/${id}`);
    return response.data;
  },

  create: async (data: UserCreate): Promise<{ data: { user: User } }> => {
    const response = await api.post<{ data: { user: User } }>('/users', data);
    return response.data;
  },

  update: async (id: number, data: UserUpdate): Promise<{ data: { user: User } }> => {
    const response = await api.put<{ data: { user: User } }>(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/users/${id}`);
  }
};

